import { render, staticRenderFns } from "./ProductImages.vue?vue&type=template&id=cfb72b3a&scoped=true&"
import script from "./ProductImages.vue?vue&type=script&lang=js&"
export * from "./ProductImages.vue?vue&type=script&lang=js&"
import style0 from "./ProductImages.vue?vue&type=style&index=0&id=cfb72b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb72b3a",
  null
  
)

export default component.exports